import {SvgIcon, useTheme} from '@mui/material';

interface IProps {
	flip?: boolean;
}

export default function EventBulletIcon({flip}: IProps) {
	const theme = useTheme();
	
	return (
		<SvgIcon className={flip ? '-scale-100' : ''} width="16" height="16" viewBox="0 0 16 16">
			<path opacity="0.4"
			      d="M7.17999 5.68005L10.5467 8.20672V11.9467C10.5467 12.5867 9.77333 12.9067 9.31999 12.4534L5.86666 9.00672C5.31333 8.45339 5.31333 7.55339 5.86666 7.00005L7.17999 5.68005Z"
			      fill={theme.palette.primary.main}/>
			<path
				d="M10.5468 4.05328V8.20662L7.18018 5.67995L9.32017 3.53995C9.77351 3.09328 10.5468 3.41328 10.5468 4.05328Z"
				fill={theme.palette.primary.main}/>
		</SvgIcon>
	);
}
